// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1414":"4ea374c8","3838":"794a1bcd","6401":"10c68892","6932":"42ba0fed","8193":"87efc920"}[chunkId] + ".chunk.css";
};